export function parameterizedURLQuery(
  obj: Record<string, string | string[] | boolean | undefined> | undefined,
): string {
  if (!obj) return "";
  const merged: string[] = Object.entries(obj)
    .map(([k, value]) => {
      if (
        value === undefined ||
        value === "" ||
        value === "undefined" ||
        (Array.isArray(value) && value.length === 0) ||
        (Array.isArray(value) && value.length === 1 && value[0] === "") // <-- ignore [""]
      ) {
        return undefined; // skip invalid values
      }

      if (Array.isArray(value)) {
        return `${encodeURIComponent(k)}=${encodeURIComponent(value.join(","))}`;
      }

      if (typeof value === "string") {
        return `${encodeURIComponent(k)}=${encodeURIComponent(value)}`;
      }

      if (typeof value === "boolean") {
        return `${encodeURIComponent(k)}=${String(value)}`;
      }

      return undefined;
    })
    .filter((value): value is string => value !== undefined);

  return merged.join("&");
}

export function parseUrlQuery(param: string | undefined): string[] | undefined {
  if (!param) return undefined;
  const arr = param
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);
  return arr.length > 0 ? arr : undefined;
}

export function cleanParams<T extends Record<string, any>>(params: T): Partial<T> {
  return Object.fromEntries(
    Object.entries(params).filter(([_, v]) => {
      if (v === undefined || v === "" || v === "undefined") return false;
      if (Array.isArray(v)) {
        const filtered = v.filter((x) => x !== "" && x !== undefined && x !== "undefined");
        return filtered.length > 0;
      }
      return true;
    }),
  ) as Partial<T>;
}
